import {Link} from 'react-router';

import {brandT} from '@/lib/types/brand.types';
import {dataTableActionT, dataTableColumnT} from '@/lib/types/dataTable.types';

export const renderBrandTableStats = (
  totalBrands: number | undefined | null,
  activeBrands: number | undefined | null,
  inactiveBrands: number | undefined | null
) => [
  {
    title: 'Total Brands',
    value: totalBrands,
    subtitle: 'This Month',
    change: 1.03,
    icon: 'ri-price-tag-3-line',
    color: 'primary',
    cardClass: 'Brands-main-card primary',
  },
  {
    title: 'Active Brands',
    value: activeBrands,
    subtitle: 'This Month',
    change: 0.36,
    icon: 'ri-check-line',
    color: 'secondary',
    cardClass: 'Brands-main-card secondary',
  },
  {
    title: 'Inactive Brands',
    value: inactiveBrands,
    subtitle: 'This Month',
    change: -1.28,
    icon: 'ri-close-line',
    color: 'warning',
    cardClass: 'Brands-main-card warning',
  },
];

export const brandColumns: dataTableColumnT<'Brand'>[] = [
  {
    header: 'Status',
    field: 'brand_id',
    render: (row: brandT) => (
      <span className={`badge bg-${!row.date_removed ? 'success' : 'danger'} text-white`}>
        {!row.date_removed ? 'Active' : 'Inactive'}
      </span>
    ),
  },
  {
    header: 'Brand Name',
    field: 'brand_name',
    render: (row: brandT) => (
      <Link className="text-primary hover:text-primary dark:text-primary" to={`/brands/${row.brand_id}`}>
        {row.brand_name}
      </Link>
    ),
  },
  {header: 'License Number', field: 'brand_license_number'},
  {header: 'Description', field: 'brand_description'},
];

export const brandActions = (
  isAdmin: boolean,
  handleEditBrandClick: (row: brandT) => void,
  handleDeleteBrandClick: (row: brandT) => void
): dataTableActionT<'Brand'>[] => [
  {
    icon: 'ri-pencil-line',
    color: 'info',
    handler: handleEditBrandClick,
    permission: () => isAdmin,
  },
  {
    icon: 'ri-delete-bin-line',
    color: 'danger',
    handler: handleDeleteBrandClick,
    permission: () => isAdmin,
  },
];
